import React, { FunctionComponent } from 'react';
import { ActivityIndicator, StyleSheet, Text } from 'react-native';
import { WebView } from './WebView';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IAppStore } from '../../HomeWorkouts';
import Theme from '../../theme';
import { defaultScale } from '../../utils';
import { closeWebViewModalPressed, ICloseWebViewModalPressed } from '../redux/uiActions';
import BaseModal from './BaseModal';
import CloseButton from './CloseButton';

interface IMappedProps {
  modalOpen: boolean;
  url?: string;
}

interface IMappedDispatch {
  closeModalPress(): void;
}

const WebViewModal: FunctionComponent<IMappedProps & IMappedDispatch> = (
  {
    modalOpen,
    url,
    closeModalPress,
  },
) => {
  return (
    <BaseModal
      forcePopup
      isModalVisible={modalOpen}
      hideCloseButton
      showHeader={false}
      useSafeAreaView
      bodyStyle={styles.modalContent}
    >
      {!url && (
        <Text>Error: url required</Text>
      )}

      {url && (
        <WebView
          source={{ uri: url }}
          startInLoadingState
          renderLoading={() =>
            <ActivityIndicator
              animating
              size='small'
              color={Theme.PRIMARY}
              style={styles.webviewLoading}
            />
          }
        />
      )}

      <CloseButton onPress={closeModalPress} style={styles.closeButton} />
    </BaseModal>
  );
};

const styles = StyleSheet.create({
  webviewLoading: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Theme.WHITE,
  },
  modalContent: {
    padding: 0,
  },
  closeButton: {
    position: 'absolute',
    top: defaultScale(20),
    right: defaultScale(20),
  },
});

const mapStateToProps = (state: IAppStore): IMappedProps => ({
  modalOpen: state.ui.webviewModalOpen,
  url: state.ui.webviewModalUrl,
});

const mapDispatchToProps = (dispatch: Dispatch<ICloseWebViewModalPressed>): IMappedDispatch => ({
  closeModalPress: () => dispatch(closeWebViewModalPressed()),
});

export default connect(mapStateToProps, mapDispatchToProps)(WebViewModal);
